export default {
    activeWorkBegin(state) {
        state.loading = true;
    },

    activeWorkSuccess(state, data) {
        state.work = data.work;
        state.workteam = data.workteam.members;
        state.workUserRole = data.workUserRole;
        state.loading = false;
    },
    activeWorkReset(state) {
        state.work = null;
        state.workteam = null;
        state.workUserRole = null;
        state.loading = false;
    },
    activeWorkErr(state, err) {
        state.work = null;
        state.workteam = null;
        state.workUserRole = null;
        state.loading = false;
        state.error = err;
    },
};
